import { createConfirmation } from 'react-confirm';
import Confirm from './Confirm';

export default createConfirmation(Confirm);



// WEBPACK FOOTER //
// /src/components/Confirm/Confirm.func.js